<div class="modal-detail-container hide-modal-detail">
    <div class="modal-detail" [style.width]="isAlert ? '400px' : ''">
        <ng-content></ng-content>
    </div>
    <div class="modal-detail-mask"></div>
</div>
